import {combineReducers} from 'redux';
import auth from './authenticationReducer';
import briefs from './briefsReducer';
import currentPage from './currentPageReducer';

const appReducer = combineReducers({
  auth,
  briefs,
  currentPage
});

const rootReducer = (state, action) => {
  if(action.type === 'LOGOUT_USER_SUCCESS') {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
